module.exports = __webpack_public_path__ + "img/1.aaab3876.png";